import React from "react";
import { ListDetail } from "../web/ListDetail";
import { DesignerSettingsList } from "./SettingsList";
import { AboutYou } from "./AboutYou";
import { YourLocation } from "./YourLocation";
import { EmptyDetailCard } from "../core/EmptyDetailCard";
import { useSettingsCategoryFromRoute } from "./params";
import { Path } from "../Path";
import { useNavigate } from "react-router-dom";
import { InvitationsList } from "./InvitationsList";
import { NotificationsList } from "./NotificationsList";
import { CloseAccount } from "./CloseAccount";
import { RecyclingBin } from "./RecyclingBin";
import { Billing } from "./Billing";
import { Storage } from "./Storage";
import { Statistics } from "./Statistics";
import { EmailInbox } from "./EmailInbox";

export const Settings = () => {
  const category = useSettingsCategoryFromRoute();
  const navigate = useNavigate();

  const onListItemSelected = (id) => {
    navigate(Path.settings().category(id));
  };

  const SelectedCategory = () => {
    if (category === "about-you") {
      return <AboutYou />;
    }
    if (category === "your-location") {
      return <YourLocation />;
    }
    if (category === "invites") {
      return <InvitationsList />;
    }
    if (category === "recycling-bin") {
      return <RecyclingBin />;
    }
    if (category === "billing") {
      return <Billing />;
    }
    if (category === "storage") {
      return <Storage />;
    }
    if (category === "notifications") {
      return <NotificationsList />;
    }
    if (category === "statistics") {
      return <Statistics />;
    }
    if (category === "email-inbox") {
      return <EmailInbox />;
    }
    if (category === "close-account") {
      return <CloseAccount />;
    }

    return <EmptyDetailCard text="Select setting group from list on the left" />;
  };
  const ListView = () => <DesignerSettingsList selectedListItemId={category} onListItemSelected={onListItemSelected} />;

  return <ListDetail ListView={ListView} DetailView={SelectedCategory} />;
};
